import EditUser from "../components/edit-user";
import {MfaApplications} from "../util/mfa_applications";
import {useParams} from "react-router-dom";

const EditUserRoute = (props: {mfaApplications: MfaApplications}) => {
    let params = useParams();
    return <EditUser
        domain={params['domain'] || ''}
        userName={params['userName'] || ''}
        mfaApplications={props.mfaApplications}
    />
}
export default EditUserRoute;
